import { injectIntl } from 'react-intl';

import LoadMoreButton from './LoadMoreButton';

export default injectIntl(LoadMoreButton);
